import { Component } from '@angular/core';
import { LaunchDialogService } from '@spartacus/storefront';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-consent-management-dialog',
    templateUrl: './consent-management-dialog.component.html',
    imports: [TranslatePipe]
})
export class ConsentManagementDialogComponent {
  isWithdraw = false;

  constructor(
    protected launchDialogService: LaunchDialogService
  ) {
  }

  withdraw(): void {
    this.launchDialogService.closeDialog(!this.isWithdraw);
  }

  cancelWithdraw(): void {
    this.launchDialogService.closeDialog(this.isWithdraw);
  }
}
